import { cmsApiClient } from '@/config/httpClients';
import type { CMSBlogPageResponse } from './schemas';
import { CMSBlogPageSchema } from './schemas';
import type { QueryFunctionContext } from '@tanstack/react-query';

const getBlogContent = async ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext) => {
  const queryKeyFilter = queryKey[1];

  const filter =
    queryKeyFilter !== 'all_categories'
      ? `&filter[categories:contains]=${queryKeyFilter}`
      : '';
  const response = await cmsApiClient
    .get<CMSBlogPageResponse>(
      `collections/articles/entries?limit=10&page=${pageParam}&sort=-date&fields=id,title,date,slug,feature_image,categories,excerpt${filter}`
    )
    .json();
  const parsedData = CMSBlogPageSchema.safeParse(response);
  if (!parsedData.success) {
    console.error('ZOD ERROR ==>', parsedData);
  }
  return response;
};

export { getBlogContent };
